import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import {
  AlertServiceMaster_create,
  AlertServiceMaster_update,
  AlertServiceMaster_delete,
  AlertServiceMaster_readById,
  AlertServiceMaster_readAll,
  AlertServiceMaster_ReadAllPaginated,
  AlertServiceMaster_UpdateStatus
} from 'src/app/GlobalVariables';
import { AlertsServiceMasterCreateRequestDTO, AlertsServiceMasterDeleteRequestDTO, AlertsServiceMasterDTO, AlertsServiceMasterList, AlertsServiceMasterReadAllPaginatedRequestDTO, AlertsServiceMasterReadByIdRequestDTO, AlertsServiceMasterUpdateRequestDTO, AlertsServiceMasterUpdateStatusRequestDTO } from './services.interface';
import { PaginatedDTO } from 'src/app/Common/common.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertServiceMasterService {
  constructor(private http: HttpClient) {}

  AlertServiceMaster_create(data: AlertsServiceMasterCreateRequestDTO): Observable<AlertsServiceMasterDTO> {
    return this.http.post<AlertsServiceMasterDTO>(AlertServiceMaster_create, data);
  }

  AlertServiceMaster_update(data: AlertsServiceMasterUpdateRequestDTO): Observable<AlertsServiceMasterDTO> {
    return this.http.post<AlertsServiceMasterDTO>(AlertServiceMaster_update, data);
  }

  AlertServiceMaster_delete(data: AlertsServiceMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(AlertServiceMaster_delete, data);
  }

  AlertServiceMaster_readById(data: AlertsServiceMasterReadByIdRequestDTO): Observable<AlertsServiceMasterDTO> {
    return this.http.post<AlertsServiceMasterDTO>(AlertServiceMaster_readById, data);
  }

  AlertServiceMaster_readAll(): Observable<AlertsServiceMasterList> {
    return this.http.get<AlertsServiceMasterList>(AlertServiceMaster_readAll);
  }

  AlertServiceMaster_ReadAllPaginated(data: AlertsServiceMasterReadAllPaginatedRequestDTO): Observable<AlertsServiceMasterList> {
    return this.http.post<AlertsServiceMasterList>(AlertServiceMaster_ReadAllPaginated, data);
  }

  AlertServiceMaster_UpdateStatus(data: AlertsServiceMasterUpdateStatusRequestDTO): Observable<AlertsServiceMasterDTO> {
    return this.http.post<AlertsServiceMasterDTO>(AlertServiceMaster_UpdateStatus, data);
  }
}
